"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderCompact = void 0;
const react_1 = __importStar(require("react"));
const react_outside_click_handler_1 = __importDefault(require("react-outside-click-handler"));
const icons_1 = require("../../../theme/icons");
const buttons_1 = require("../../buttons");
const forms_1 = require("../../forms");
const other_1 = require("../../other");
const __1 = require("..");
const HeaderCompact_styles_1 = require("./HeaderCompact.styles");
const HeaderCompact = ({ userDetails, onLogoutClick, onSettingsClick, projectName, savingText, primaryButton, shareButton, guestSettingsButton, settingsLabel, logoutLabel, editHandler, loggedIn, url, secondaryButton, children, errorSummaryButtonLabel, errorSummary, isProjectLocked, projectsLabel, loginButton, }) => {
    const initials = userDetails.username
        .split(" ")
        .map((n) => n[0])
        .join("");
    const profilePicture = userDetails.profilePic;
    const labels = {
        settings: settingsLabel || "Settings",
        logout: logoutLabel || "Logout",
    };
    const [hide, hideMenu] = (0, react_1.useState)(true);
    const onClickOutside = (0, react_1.useMemo)(() => () => {
        if (!hide) {
            hideMenu(!hide);
        }
    }, [hide]);
    const showHideMenu = () => {
        hideMenu(!hide);
    };
    const openDesignerPage = () => {
        const targetWindowName = "designerTab";
        const dashboardTab = window.open(url, targetWindowName);
        if (!dashboardTab || dashboardTab.closed) {
            window.open(url, "_blank");
        }
        else {
            dashboardTab.focus();
        }
    };
    return (react_1.default.createElement(HeaderCompact_styles_1.Wrapper, null,
        react_1.default.createElement(HeaderCompact_styles_1.HeaderWrapper, null,
            react_1.default.createElement(HeaderCompact_styles_1.ProjectContainer, null,
                url ? (react_1.default.createElement(HeaderCompact_styles_1.LogoContainer, { onClick: openDesignerPage },
                    react_1.default.createElement(icons_1.SwegonLogo, { width: 94.1, height: 24.1 }))) : (react_1.default.createElement(HeaderCompact_styles_1.LogoContainerBox, null,
                    react_1.default.createElement(icons_1.SwegonLogo, { width: 94.1, height: 24.1 }))),
                projectName && (react_1.default.createElement(HeaderCompact_styles_1.ProjectLabel, null,
                    react_1.default.createElement(forms_1.EditableTitle, { name: projectName, editHandler: editHandler, isEditable: !isProjectLocked }))),
                errorSummary && (react_1.default.createElement(HeaderCompact_styles_1.ErrorSummaryWrapper, null,
                    react_1.default.createElement(other_1.ErrorSummary, { buttonLabel: errorSummaryButtonLabel || "", summary: errorSummary }))),
                react_1.default.createElement(HeaderCompact_styles_1.SavingWrapper, null, savingText)),
            children && react_1.default.createElement(HeaderCompact_styles_1.ChildrenWrapper, null, children),
            react_1.default.createElement(HeaderCompact_styles_1.ActionContainer, null,
                loginButton && react_1.default.createElement(HeaderCompact_styles_1.ShareBtn, null, loginButton),
                guestSettingsButton && react_1.default.createElement(HeaderCompact_styles_1.ButtonWrapper, null, guestSettingsButton),
                shareButton && react_1.default.createElement(HeaderCompact_styles_1.ShareBtn, null, shareButton),
                secondaryButton && react_1.default.createElement(HeaderCompact_styles_1.SecondaryBtn, null, secondaryButton),
                react_1.default.createElement(HeaderCompact_styles_1.PrimaryBtn, { "$lastElement": !loggedIn }, primaryButton),
                loggedIn && (react_1.default.createElement(react_outside_click_handler_1.default, { onOutsideClick: onClickOutside },
                    react_1.default.createElement(HeaderCompact_styles_1.InitialsButtonWrapper, null,
                        react_1.default.createElement(buttons_1.InitialsButton, { label: profilePicture || initials, onClick: showHideMenu }),
                        react_1.default.createElement(HeaderCompact_styles_1.UserSettingsMenuWrapper, { "$hidden": hide },
                            react_1.default.createElement(__1.UserSettingsMenu, { username: userDetails.username, email: userDetails.email, settingsLabel: labels.settings, logoutLabel: labels.logout, onLogoutClick: onLogoutClick, onSettingsClick: onSettingsClick, url: url, projectsLabel: projectsLabel }))))))),
        react_1.default.createElement(HeaderCompact_styles_1.HorizontalLine, null)));
};
exports.HeaderCompact = HeaderCompact;
//# sourceMappingURL=HeaderCompact.js.map